import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../GL/LoanReport.css';
import { formatDateToDDMMYYYY } from '../../utils/dateUtils';

const CDLoanReport = () => {
  const [loanReports, setLoanReports] = useState([]);

  // Helper function to remove duplicate entries
  const removeDuplicates = (reports) => {
    const uniqueReports = reports.filter(
      (report, index, self) =>
        index ===
        self.findIndex(
          (r) =>
            r.account_number === report.account_number &&
            r.loan_date === report.loan_date
        )
    );
    return uniqueReports;
  };

  useEffect(() => {
    const fetchLoanReport = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001'}/api/cd-loan-reports`, {
          headers: { 'Content-Type': 'application/json' },
        });

        console.log('API Response:', response.data);

        if (response.status === 200 && response.data.length > 0) {
          const filteredReports = removeDuplicates(response.data);
          setLoanReports(filteredReports);
        } else {
          console.warn('No data returned from API or empty array');
          setLoanReports([]);
        }
      } catch (error) {
        console.error('Error fetching loan reports:', error.message);
      }
    };

    fetchLoanReport();
  }, []);

  // Print functionality
  const handlePrint = () => {
    const printWindow = window.open('', '_blank', 'width=600,height=600');
    
    // Create the HTML content for printing
    const printContent = `
      <html>
        <head>
          <title>CD Loan Report</title>
          <style>
            body { font-family: Arial, sans-serif; }
            table { width: 100%; border-collapse: collapse; margin: 20px 0; }
            th, td { padding: 8px; border: 1px solid #ddd; text-align: left; }
            th { background-color: #f4f4f4; }
          </style>
        </head>
        <body>
          <h2>CD Loan Report</h2>
          <table>
            <thead>
              <tr>
                <th>Account Number</th>
                <th>Date</th>
                <th>Name</th>
                <th>Recommended By</th>
                <th>Period (Days)</th>
                <th>Loan Amount</th>
                <th>Monthly Installment</th>
              </tr>
            </thead>
            <tbody>
              ${loanReports.map(
                (report) => `
                  <tr>
                    <td>${report.account_number}</td>
                    <td>${formatDateToDDMMYYYY(report.loan_date)}</td>
                    <td>${report.name}</td>
                    <td>${report.recommended_by}</td>
                    <td>${report.period}</td>
                    <td>${report.loan_amount}</td>
                    <td>${report.monthly_installment}</td>
                  </tr>`
              ).join('')}
            </tbody>
          </table>
        </body>
      </html>
    `;

    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
  };

  // Go Back functionality
  const handleBack = () => {
    window.history.back();
  };

  return (
    <div className="loan-report-container">
      {/* Back Button */}
      <div className="back-button-container" onClick={handleBack}>
        <span className="back-arrow">←</span>
        <span className="back-text">Back</span>
      </div>
  
      {/* Loan Report Table */}
      <h2>CD Loan Report</h2>
      <table className="report-table">
        <thead>
          <tr>
            <th>Account Number</th>
            <th>Date</th>
            <th>Name</th>
            <th>Recommended By</th>
            <th>Period (Days)</th>
            <th>Loan Amount</th>
            <th>Monthly Installment</th>
          </tr>
        </thead>
        <tbody>
          {loanReports.length > 0 ? (
            loanReports.map((report, index) => (
              <tr key={index}>
                <td>{report.account_number}</td>
                <td>{formatDateToDDMMYYYY(report.loan_date)}</td>
                <td>{report.name}</td>
                <td>{report.recommended_by}</td>
                <td>{report.period}</td>
                <td>{report.loan_amount}</td>
                <td>{report.monthly_installment}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7">No Loan Reports Found</td>
            </tr>
          )}
        </tbody>
      </table>
  
      {/* Print Button */}
      <div className="buttons-container">
        <button className="print-button" onClick={handlePrint}>
          Print Report
        </button>
      </div>
    </div>
  );
};  

export default CDLoanReport;
